import { css } from 'lit';
export const selectTokenStyle = css `
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }
`;
//# sourceMappingURL=select-token.style.js.map